/**
 * Returns whether the given object matches the CesiumIonExternalAssetType type
 * @param obj Object to check
 */
export function isCesiumIonExternalAssetType(obj) {
    if (typeof obj !== "string")
        return false;
    switch (obj) {
        case "BING" /* CesiumIonExternalAssetType.Bing */:
            return true;
        default:
            return false;
    }
}
